(() => {
  const bound = new WeakSet();
  function init(scope = document) {
    scope.querySelectorAll('[data-ph44-donation]').forEach(form => {
      if (bound.has(form)) return;
      bound.add(form);
      const select = form.querySelector('[data-amount-select]');
      const buttons = [...form.querySelectorAll('[data-variant]')];
      const feeRow = form.querySelector('[data-offset-row]');
      const feeChoice = form.querySelector('[data-offset-choice]');
      const errorBox = form.querySelector('[data-checkout-error]');
      const submit = form.querySelector('[type=submit]');
      const variants = JSON.parse(form.querySelector('[data-gift-variants]').textContent).variants;
      const plans = [...form.querySelectorAll('[name=selling_plan]')];
      const anonymous = form.querySelector('[data-anonymous]');
      const publicName = form.querySelector('[data-public-name]');
      const purposes = [...form.querySelectorAll('[data-purpose]')];
      const deskSelect = form.querySelector('[data-desk]');
      const countryRow = form.querySelector('[data-country-row]');
      const destination = form.querySelector('[data-destination-value]');
      const planId = () => plans.find(input => input.checked)?.value || '';
      const total = form.querySelector('[data-gift-total]');
      const currency = form.dataset.currency;
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const shortMoney = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 2 });
      let busy = false;
      const refresh = () => {
        const opt = select.selectedOptions[0];
        const id = planId();
        const current = variants.find(variant => variant.id === select.value);
        const amountLabel = form.querySelector('[data-amount-label]');
        amountLabel.textContent = id ? amountLabel.dataset.monthlyLabel : amountLabel.dataset.onceLabel;
        const purpose = purposes.find(input => input.checked)?.value || 'Where most needed';
        const specificCountry = purpose === 'Specific country';
        countryRow.hidden = !specificCountry;
        deskSelect.disabled = !specificCountry;
        destination.value = specificCountry ? deskSelect.value : purpose;
        for (const option of select.options) {
          const variant = variants.find(item => item.id === option.value);
          const allocation = variant?.plans.find(plan => plan.id === id);
          option.disabled = !!id && !allocation;
          option.textContent = allocation?.price || variant?.price || option.textContent;
        }
        if (opt?.disabled) {
          const available = [...select.options].find(option => !option.disabled);
          if (available) { select.value = available.value; return refresh(); }
        }
        buttons.forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.variant === select.value));
          const option = [...select.options].find(item => item.value === button.dataset.variant);
          button.disabled = !!option?.disabled;
          button.textContent = option?.textContent || '';
        });
        const giftAllocation = current?.plans.find(plan => plan.id === id);
        const giftMinor = giftAllocation?.priceMinor ?? current.priceMinor;
        const offsetAllocation = current?.offsetPlans.find(plan => plan.id === id);
        const offsetMinor = offsetAllocation?.priceMinor ?? current.offsetPriceMinor;
        if (feeRow) {
          const allocation = offsetAllocation;
          feeRow.hidden = !opt?.dataset.offset || (!!id && !allocation);
          if (feeRow.hidden) feeChoice.checked = false;
          const copy = form.querySelector('[data-offset-copy]');
          copy.textContent = copy.dataset.offsetCopy.replace('__amount__', shortMoney.format(giftMinor / 100));
        }
        const totalMinor = giftMinor + (feeChoice?.checked && !feeRow.hidden ? offsetMinor : 0);
        total.textContent = (id ? total.dataset.monthlyTotal : total.dataset.onceTotal).replace('__amount__', money.format(totalMinor / 100));
        total.hidden = false;
        if (anonymous) {
          form.querySelector('[data-public-name-row]').hidden = anonymous.checked;
          publicName.disabled = anonymous.checked;
          publicName.required = !anonymous.checked;
          form.querySelector('[data-recognition]').value = anonymous.checked ? 'No' : 'Yes';
        }
      };
      const frequency = form.querySelector('[data-frequency]');
      if (frequency) frequency.hidden = false;
      plans.forEach(input => input.addEventListener('change', refresh));
      if (feeChoice) feeChoice.addEventListener('change', refresh);
      purposes.forEach(input => input.addEventListener('change', refresh));
      deskSelect.addEventListener('change', refresh);
      if (anonymous) { anonymous.disabled = false; anonymous.addEventListener('change', refresh); }
      form.querySelector('[data-amount-buttons]').hidden = false;
      select.hidden = true;
      select.addEventListener('change', refresh);
      buttons.forEach(button => button.addEventListener('click', () => {
        if (busy) return;
        select.value = button.dataset.variant;
        refresh();
      }));
      const deskParam = new URLSearchParams(location.search).get('desk');
      const deskOption = [...deskSelect.options].find(option => option.value.toLowerCase() === deskParam?.toLowerCase());
      if (deskOption) { deskSelect.value = deskOption.value; purposes.find(input => input.value === 'Specific country').checked = true; }
      refresh();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        busy = true;
        submit.disabled = true;
        form.setAttribute('aria-busy', 'true');
        errorBox.hidden = true;
        const properties = {};
        for (const [key, value] of new FormData(form)) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value) properties[match[1]] = value;
        }
        const items = [{ id: select.value, quantity: 1, properties }];
        const subscription = planId();
        if (subscription) items[0].selling_plan = subscription;
        const feeId = select.selectedOptions[0]?.dataset.offset;
        if (feeChoice?.checked && feeId && !feeRow.hidden) {
          const contribution = { id: feeId, quantity: 1, properties: { 'For field gift': select.value } };
          if (subscription) contribution.selling_plan = subscription;
          items.push(contribution);
        }
        try {
          const response = await fetch(form.dataset.root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : form.dataset.error);
          // No cart clear: any existing merchandise remains in the customer's cart.
          location.assign(form.dataset.root + 'checkout');
        } catch (error) {
          errorBox.textContent = error.message || form.dataset.error;
          errorBox.hidden = false;
          errorBox.focus();
          busy = false;
          submit.disabled = false;
          form.removeAttribute('aria-busy');
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
